import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';

import { loadMoreAMConnectionsProp, SimpleLoadingComponent } from '../../utils/apollo';

import AMConnectionsView from './connections-view';
import { STUDENT_CONNECTION_FRAGMENT, LIMIT, SCHOOL_YEARS } from './constants';
import { queryErrorsToWarnings } from '../../components/GraphQLError';

const query = gql`
  query AMPlusYearConnections ($schoolYear: Int, $page: Int, $limit: Int) {
    viewer {
      id
      enabledFeatures
      studentConnections: amStudentConnectionsBySchoolYear(schoolYear: $schoolYear, page: $page, limit: $limit) {
        pagination {
          page
          totalCount
          hasNextPage
        }
        results {
          ...AMStudentResults
        }
      }
    }
  }
  ${STUDENT_CONNECTION_FRAGMENT}
`;

const graphqlData = graphql(query, {
  options: ({ schoolYear=SCHOOL_YEARS[0].value }) => ({
    variables: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      page: 1,
      limit: LIMIT,
      schoolYear,
    },
  }),
  props: compose(
    queryErrorsToWarnings(['studentConnections']),
    loadMoreAMConnectionsProp(query),
  ),
});
export default SimpleLoadingComponent(graphqlData)(AMConnectionsView);
